module.exports = {
  common: {
    save: 'บันทึก',
    cancel: 'ยกเลิก',
    combinationTitle: 'กฎการปล่อยเอกสารอัตโนมัติ (แบบผสม)',
    ruleTitle: 'กฎการปล่อยเอกสารอัตโนมัติ',
    AutomaticOrderReleaseTriggerSettings: 'การตั้งค่าการกระตุ้นการปล่อยเอกสารอัตโนมัติ',
    ReleaseGuaranteeSetting: 'การตั้งค่าประกันการปล่อยเอกสาร',
    docType: 'ประเภทใบตราส่งสินค้า',
    customerSelfRelease: 'ประเภท HBL',
    releaseType: 'วิธีการออกใบตราส่งสินค้า',
    cargoSource: 'แหล่งที่มาของสินค้า',
    creditObject: 'วัตถุประสงค์การควบคุมเครดิตการปล่อยเอกสาร',
    receivableType: 'ประเภทรายรับรายจ่าย',
    creditLimitedDate: 'ระยะเวลาบัญชีควบคุมเครดิต',
    creditLimitAmount: 'วงเงินควบคุมเครดิต',
    customerType: 'ประเภทหน่วยงานที่มอบหมาย'
  },
  selectBranch: 'เลือกสาขา:',
  ApplyTheHeadOfficeConfiguration: 'ใช้การตั้งค่าของสำนักงานใหญ่',
  enterRuleName: 'กรุณากรอกชื่อกฎ',
  add: 'เพิ่มใหม่',
  edit: 'แก้ไข',
  deletes: 'ลบ',
  refresh: 'รีเฟรช',
  ruleName: 'ชื่อกฎการปล่อยเอกสารอัตโนมัติ',
  businessTypes: 'ประเภทธุรกิจที่適用',
  conversionRules: 'กฎการประมวลผลที่เกี่ยวข้อง',
  ruleDescription: 'คำอธิบาย',
  orderNum: 'ลำดับที่',
  ruleGroupName: 'ชื่อกฎการปล่อยเอกสารอัตโนมัติ (แบบผสม)',
  ruleNames: 'รวมถึงชื่อกฎ',
  performActions: 'รวมถึงการดำเนินการ',
  officeCode: 'สาขา',
  customerCompany: 'ลูกค้าที่適用',
  refreshSuccess: 'รีเฟรชสำเร็จ',
  operationSuccess: 'ดำเนินการสำเร็จ',
  dialogRuleName: 'ชื่อกฎ (แบบผสม)',
  RuleNamePlaceholder: 'กรุณากรอกชื่อกฎ',
  ruleDescriptionPlaceholder: 'เนื้อหาคำอธิบาย',
  AnyRuleTitle: '適用กฎใดกฎหนึ่งต่อไปนี้',
  AllRuleTitle: '適用กฎทั้งหมดต่อไปนี้',
  PerformRelatedActions: 'ดำเนินการที่เกี่ยวข้อง',
  meetConditions: 'ตรงตามเงื่อนไข',
  meetConditionsRemind: 'ปล่อยเอกสารอัตโนมัติเมื่อตรงตามเงื่อนไข (สถานะเอกสารอัปเดตเป็น "สามารถปล่อยได้")',
  dissatisfaction: 'ไม่ตรงตามเงื่อนไข',
  runningRules: 'ดำเนินการชุดกฎถัดไป',
  runningRulesRemind: 'ไม่ปล่อยเอกสารเมื่อไม่ตรงตามเงื่อนไข (สถานะเอกสารอัปเดตเป็น "รอการชำระเงิน")',
  remark1: 'หมายเหตุ: เมื่อเลือก "ดำเนินการชุดกฎถัดไป" สำหรับทุกชุดกฎในกรณี "ไม่ตรงตามเงื่อนไข" และผลการประเมินจริงทั้งหมดไม่ตรงตามเงื่อนไข',
  remark2: 'สถานะเอกสารจะถูกอัปเดตเป็น "รอการชำระเงิน" ด้วย',
  applicableCustomers: 'ลูกค้าที่適用',
  applicableCustomersRemind1: 'การปล่อยเอกสารอัตโนมัติ適用เฉพาะลูกค้าที่มีประเภทการชำระเงินเป็น "ไม่ใช้ใบแจ้งหนี้"',
  applicableCustomersRemind2: '(คือลูกค้าที่มีระยะเวลาบัญชี)',
  conditionType: 'ประเภทเงื่อนไข',
  customerName: 'ชื่อลูกค้า',
  branchOffice: 'สาขา',
  successRemind: 'บันทึกสำเร็จ',
  toggleReminder: 'กรุณายืนยันอีกครั้งว่าจะเปลี่ยนลูกค้าที่適用เป็นทั้งหมดหรือไม่? การดำเนินการนี้จะลบข้อมูลลูกค้าในรายการด้านล่าง',
  tips: 'แจ้งเตือน',
  yes: 'ใช่',
  no: 'ไม่ใช่',
  deleteRemind: 'กรุณาเลือกข้อมูลอย่างน้อย 1 รายการเพื่อลบ!',
  ruleName1: 'ชื่อกฎ',
  meetAnyConditions: 'ตรงตามเงื่อนไขใดเงื่อนไขหนึ่งต่อไปนี้',
  meetAllConditions: 'ตรงตามเงื่อนไขทั้งหมดต่อไปนี้',
  processingRules: 'กฎการปล่อยเอกสาร',
  releaseDemand: 'ปล่อยเอกสารเมื่อได้รับเงิน',
  prompt: 'กรุณาบำรุงรักษาข้อมูล${prompt}ก่อนบันทึก',
  Tips1: 'กรุณากรอกข้อมูลกฎให้ครบถ้วน',
  equal: 'เท่ากับ',
  neq: 'ไม่เท่ากับ',
  exceed: 'เกิน',
  notMore: 'ไม่เกิน',
  SC: 'สินค้าจัดหาเอง',
  NC: 'สินค้าที่กำหนด',
  creditUsedLimitAmount: 'วงเงินที่ใช้แล้ว',
  customerIssuing: 'ลูกค้าออกเอกสารเอง',
  issuedCompany: 'บริษัทออกเอกสารเอง',
  original: 'ต้นฉบับ',
  telexRelease: 'ปล่อยทางอิเล็กทรอนิกส์',
  accountingPeriod: 'ตั้งค่างวดบัญชีควบคุมเครดิต',
  client: 'หน่วยมอบหมาย',
  agent: 'ตัวแทนสินค้าที่กำหนด',
  settlement: 'วัตถุการชำระเงิน',
  collection: 'รับเงิน',
  maintenanceName: 'บำรุงรักษาชื่อกฎ (รวม)',
  rule: 'กฎ',
  whole: 'ทั้งหมด',
  TriggerTheNode: 'จุดกระตุ้น',
  ScheduledPollingTriggersAutomaticOrderVerification: 'ตรวจสอบการปล่อยเอกสารอัตโนมัติโดยการสอบถามตามเวลา',
  ApplyBranchOfficeSettings: 'ตั้งค่าสาขาที่ใช้',
  automatic: 'อัตโนมัติ',
  daily: 'ทุกวัน',
  blacklist: 'บัญชีดำ',
  EffectiveList: 'บัญชีที่生效',
  ChargeRecordState: 'การตัดสินสถานะของรายการค่าธรรมเนียม',
  ChargeRecordState0: 'ต้องมีค่าธรรมเนียมที่เรียกเก็บ',
  ChargeRecordState1: 'ต้องมีค่าใช้จ่ายที่วัตถุของการตั้งถิ่นฐานเป็นหน่วยงานหลักโดยไม่คำนึงถึงการรับและชำระเงิน',
  ChargeRecordState2: 'ไม่ว่าจะมีค่าใช้จ่ายหรือไม่',
  SettlementBillMode: 'ดูรูปแบบการวางเดี่ยว',
  SettlementBillCheckCost: 'เมื่อไม่มีลูกหนี้อื่นป้อนการชำระหนี้ให้กับหน่วยงานต้นสังกัดถือว่าชำระค่าตั๋วแล้ว',
  SettlementBillCustomer: 'ตรวจสอบเฉพาะลูกหนี้ของหน่วยที่รับมอบอำนาจเท่านั้น',
  SettlementBillCustomerCheckCost: 'เมื่อไม่มีหน่วยงานที่รับมอบอำนาจเข้าบัญชีการจ่ายเงินให้หน่วยงานต้นสังกัดถือว่าหน่วยงานต้นสังกัดจ่ายแล้ว',
  CreditObjectMode: 'โหมด CS'
}
